import styled from "styled-components";
import colours from "../../assets/colours";

export const SearchableList = styled.div`
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  border: 1px solid #fff;
`;

export const ScrollArea = styled.div`
  height: 400px;
  overflow: auto;
  max-height: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 15px 20px;
  margin: 0;
  border: none;
  border-bottom: 1px solid #fff;
  border-radius: 16px;
  font-size: 20px;
  outline: none;
  transition: 0.2s;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.2);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  color: white;
  &:focus {
    background-color: rgba(255, 255, 255, 0.3);
  }
  &::placeholder {
    color: #ccc;
    opacity: 1; /* Firefox */
  }
  &[type="password"] {
    letter-spacing: 10px;
    &::placeholder {
      letter-spacing: 10px;
    }
  }
`;

export const SearchItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 18px;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const OptionSelection = styled.span`
  border: 1px solid #fff;
  padding: 3px 5px;
  margin: 0 5px 5px 0;
  display: inline-block;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const OptionsList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 20px;
  width: calc(100% - 40px);
  margin: 20px;
  border-radius: 20px;
  gap: 5px;
`;

export const LightOptionButton = styled.button<{ level: number; selected?: boolean }>`
  border: none;
  flex-grow: 1;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ selected }) => (selected ? colours.blue : "transparent")};
  border-radius: 5px;
  &:after {
    content: "";
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: rgba(0, 255, 0, ${(props) => props.level / 100});
    border: rgba(0, 0, 0, 0.3) 1px solid;
    box-shadow: ${({ level }) =>
      `0 0 ${0.2 * level}px ${level * 0.1}px rgba(0, 255, 0, 0.6)`};
    cursor: pointer;
  }
  &:hover {
    border-color: ${colours.blue};
  }
`;

export const OptionList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const DeviceOptions = styled.div`
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 20px;
  width: calc(100% - 40px);
  margin: 20px;
  border-radius: 20px;
`;

export const DeleteDevice = styled.button`
  border: none;
  outline: none;
  min-width: 26px;
  height: 26px;
  border-radius: 15px;
  background-color: #f20000;
  &:hover {
    background-color: #ff0000;
  }
  position: absolute;
  top: 2px;
  right: 2px;
  color: white;
  transition: 0.2s;
  opacity: 0;
  cursor: pointer;
`;

export const DeviceOption = styled.div<{ selected: boolean }>`
  display: block;
  outline: none;
  position: relative;
  text-align: center;
  font-size: 12px;
  width: 60px;
  height: 60px;
  background-color: white;
  border-radius: 5px;
  padding: 30px;
  border: ${({ selected }) => (selected ? "black" : "transparent")} 2px solid;
  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-color: black;
    border-radius: 2px;
  }
  &:hover ${DeleteDevice} {
    opacity: 1;
  }
`;

export const DeviceOptionTitle = styled.div`
  position: absolute;
  color: #fff;
  width: 100%;
  padding: 5px 10px;
  color: #222;
  box-sizing: border-box;
  left: 0;
`;

export const Tabs = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
`;

export const TabButtons = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 0px;
  width: 100%;
`;

export const TabButton = styled.button<{ selected: boolean }>`
  border: none;
  outline: none;
  background-color: transparent;
  color: white;
  font-size: 20px;
  cursor: pointer;
	flex-grow: 1;
	padding-bottom: 10px;
  border-bottom: ${({ selected }) => (selected ? "2px solid white" : "none")};
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: ${({ selected }) => (selected ? "block" : "none")};
  width: 100%;
`;

export const Options = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: row;
	gap: 10px;
	width: 100%;
	@media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Option = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 10px;
`;